import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Link as LinkScroll } from 'react-scroll';
import ButtonBase from '../../Buttons/ButtonBase';
import './WebinarExperts.scss';

const routeVideo = '/video/video-contacta.mp4';

const useStyles = makeStyles({
    '@media screen and (max-width: 1000px)': {
        buttonStyle: {
            minWidth: 'inherit',
            width: 296,
        },
        linkScroll: {
            width: '100%',
            display: 'contents'
        }
    },
    '@media screen and (max-width: 499.98px)': {
        buttonStyle: {
            width: '100%',
            display: 'inherit'
        },
        linkScroll: {
            display: 'block'
        }
    }
})

const WebinarExperts = () => {

    const classes = useStyles()

    return ( 
        <section className="wbExp">
            <div className="wbExp_container">
                <div className="wbExp_container-grid">
                    <div className="wbExp_container-grid__Title">
                        <p className='wbExp_title-text'>
                            Aprenda de los expertos en el tema
                        </p>
                    </div>
                    <div className="wbExp_container-grid__Video">
                        <div className="wbExp_videoContainer">
                            <video
                                className="wbExp_video"
                                controls="0"
                                poster="/img/Webinar/Experts/poster.png"
                                controlsList="nodownload"
                                playsInline
                            >
                                <source src={routeVideo} type="video/mp4"/>
                            </video>
                        </div>
                    </div>
                    <div className="wbExp_container-grid__Info">
                        <p className='wbExp_info-text'>
                            Nuestros expertos le compartirán <strong>valiosa información</strong> sobre
                            como está cambiando el <strong>mundo del derecho</strong>, la transformación digital y la Legaltech.
                        </p>
                        <div className='wbExp_info-button'>
                            <LinkScroll
                                to="webinarForm"
                                smooth="true"
                                duration={500}
                                offset={-60}
                                className={classes.linkScroll}
                            >
                                <ButtonBase
                                    type="submit"
                                    variant="secondary"
                                    buttonStyle={classes.buttonStyle}
                                >
                                    Quiero asistir al webinar
                                </ButtonBase>
                            </LinkScroll>
                        </div>
                    </div>
                </div>
            </div>

        </section>
     );
}
 
export default WebinarExperts;